import { ModuleValueUniversal, SchemaModuleUniversal } from './module-universal';
import { JSONSchema } from '../types/json-schema';
import * as rawJSONSchemaModuleColorectalSurgery from '../../schemas/module-colorectal-surgery.json';
import { FormComponent } from '../form.component';

class ModuleValueColorectalSurgery extends ModuleValueUniversal {
  date_diagnosis?: string;
  discharge_date?: string;
  length_of_stay?: string;
  follow_up?: string;
  preoperative_cea?: string;
}

export class SchemaModuleColorectalSurgery extends SchemaModuleUniversal<ModuleValueColorectalSurgery> {
  schema: JSONSchema<ModuleValueUniversal>;

  constructor() {
    super();

    this.loadSchema(rawJSONSchemaModuleColorectalSurgery);
  }

  hook(form: FormComponent) {
    super.hook(form);

    this.listenValue(
      ['discharge_date', 'date_of_surgery'],
      this.fieldHandlerDischargeDate('length_of_stay').bind(this)
    );
  }

  setupValidators() {
    super.setupValidators();

    this.validatorDateComparison('date_diagnosis', 'date_of_surgery', '<=');
    this.validatorDateComparison('date_diagnosis', 'discharge_date', '<=');
    this.validatorDateComparison('discharge_date', 'date_of_surgery', '>=');
    this.validatorDateComparison('follow_up', 'date_of_surgery', '>=');

    this.validatorDateComparison('date_of_surgery', 'date_of_birth', '>=');

    this.addValidator('preoperative_cea', (value, formProperty, form) => {
      if (value === null || value === undefined) {
        return [];
      }
      const regex = /^\d+(\.\d)?$/;
      return regex.test(value) ? [] : [{
        code: 'invalidNumber',
        path: `#/${formProperty.path}`,
        message: 'Preoperative CEA must be a number with at most one decimal place.'
      }];
    });

  }

}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-colorectal-surgery.ts